var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkModeIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18287 13.5023C6.36817 10.2347 8.38973 6.78531 11.8863 5.6498C10.7835 7.55298 10.4442 10.0485 11.064 12.5346C11.6839 15.0207 13.155 17.0649 15.0223 18.2275C11.4019 18.8665 7.99756 16.7699 7.18287 13.5023ZM11.9186 3.56133C7.15562 4.74887 4.09212 9.37313 5.24228 13.9861C6.39243 18.5992 11.2683 21.2439 16.0313 20.0564C16.9839 19.8188 17.3083 18.9634 17.272 18.3075C17.2374 17.682 16.8956 17.0018 16.2512 16.6324C14.7939 15.797 13.5325 14.1679 13.0046 12.0508C12.4768 9.93366 12.8257 7.90304 13.7202 6.48128C14.1158 5.85259 14.0982 5.0915 13.8351 4.52301C13.5592 3.92681 12.8712 3.32381 11.9186 3.56133ZM18.3933 6.00022H18.7266V6.33356H19.06V6.66689H18.7266V7.00022H18.3933V6.66689H18.06V6.33356H18.3933V6.00022ZM18.3931 11.0002H17.7265V11.667H17.06V12.3336H17.7265V13.0002H18.3931V12.3336H19.06V11.667H18.3931V11.0002ZM15.3933 8.00022H15.7266V8.33356H16.06V8.66689H15.7266V9.00022H15.3933V8.66689H15.06V8.33356H15.3933V8.00022Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIcn);
export default __webpack_public_path__ + "static/media/dark-mode-icn.d1a2e152b84c3c768722510e4b8d2bca.svg";
export { ForwardRef as ReactComponent };